export const BasicSubscriptionFormName = 'basic-subscription';

export enum BasicSubscriptionFormFields {
  ProductType = 'productType',
  EffectiveDateFrom = 'effectiveDateFrom',
  EffectiveDateTo = 'effectiveDateTo',
}
